module.exports = __webpack_public_path__ + "img/220-vietnam.8a0beafd.svg";